query GetLimits($type: LimitedType!) {
    limits(type: $type) {
        shouldShowWarningInTrial
        currentUsage
        allTimeUsage
        currentPlanLimit
        isEnforced
        canAdd
        currentPlanName
        upgradePlanLimit
        upgradePlanName
        humanReadableType
        tierPlanLimit
    }
}
